import * as Sentry from "@sentry/gatsby";

Sentry.init({
  dsn: "https://6a547c98d0b07e02b73f9823056ab187@us.sentry.io/4506594654486528",
  environment: process.env.GATSBY_PUBLIC_SENTRY_ENVIRONMENT,

  integrations: [
    Sentry.replayIntegration(),
    ],

  tracesSampleRate: 1.0,
  
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});